module.exports = __webpack_public_path__ + "static/media/volldamm.f25a2564.jpg";